import { render, staticRenderFns } from "./ZGaConsumption.vue?vue&type=template&id=08cd09d9&scoped=true"
import script from "./ZGaConsumption.vue?vue&type=script&lang=js"
export * from "./ZGaConsumption.vue?vue&type=script&lang=js"
import style0 from "./ZGaConsumption.vue?vue&type=style&index=0&id=08cd09d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd09d9",
  null
  
)

export default component.exports